export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/pin-top.9c020aa9-657e6d.svg";